export default {
  primary: "#00321E",
  secondary: "",
  alert: {
    alert25: "#D86464",
    alert50: "#D86464",
    alert100: "#D86464"
  },
  warning: {
    warning25: "#fbbc44",
    warning50: "#fbbc44",
    warning100: "#fbbc44"
  },
  success: {
    success25: "#4e9a55",
    success50: "#4e9a55",
    success100: "#4e9a55"
  },
  white: "#ffffff",
  black: "#070707",
  background: {
    background25: "#F8F8F8",
    background50: "",
    background100: "#161616",
    overlay: "rgba(4, 4, 15, 0.7)"
  },
  grey: {
    grey25: "#f6f6f6",
    grey50: "#CCCCCC",
    grey100: "#808080"
  }
};
